import { validatorStringGeneric } from "./validatorStringGeneric";

const regExp = new RegExp("^[ a-zA-Z\u00C0-\u017F'.\\-]+$");

export const validatorStringTextOnly = validatorStringGeneric.matches(regExp, {
  excludeEmptyString: true,
  message:
    "May contain only characters: a-z, A-Z, ', ., -, inner spaces and accented characters"
});
